import { UcoastEl } from '@/scripts/core/UcoastEl'
import { qsOptional, qsRequired } from '@/scripts/core/global'

export class StickyHeader extends UcoastEl {
	static htmlSelector = 'sticky-header'
	header: HTMLElement
	observable: HTMLElement
	announcement?: HTMLElement
	constructor() {
		super()
		this.header = qsRequired('#shopify-section-header .header', this)
		this.observable = qsRequired('#observable')
		this.connectedCallback.bind(this)
	}

	override connectedCallback() {
		this.announcement = qsOptional('.announcement-bar')
		this.createObserver()
		this.firstLoad()
	}

	firstLoad() {
		const scrollTop = window.scrollY || document.documentElement.scrollTop
		if (scrollTop > 0) {
			this.header.classList.add('scrolled')
		} else if (scrollTop === 0) {
			this.header.classList.remove('scrolled')
		}
	}

	createObserver() {
		let observer = new IntersectionObserver(
			(_: IntersectionObserverEntry[], __: IntersectionObserver) => {
				let scrollTop =
					window.scrollY || document.documentElement.scrollTop
				if (this.announcement) {
					console.log('announcement')
					const announcementHeight = parseInt(
						getComputedStyle(document.documentElement)
							.getPropertyValue('--bar-height')
							.replace('px', '')
					)
					scrollTop -= announcementHeight

				}
				if (scrollTop > 0) {
					this.header.classList.add('scrolled')
					this.header.classList.add('animated-once')
				} else if (scrollTop <= 0) {
					this.header.classList.remove('scrolled')
				}
			}
		)

		observer.observe(this.observable)
	}
}
